import { Plural, Trans } from '@lingui/react/macro';

import ContactDetails from '@/components/ContactDetails';
import AlertBar from '@/design_system/AlertBar';
import IconWarning from '@/icons/Warning.svg';
import { useGetArticleName } from '@/models/article';
import { ArticleWithRelations, RequestWithRelations } from '@/models/request';
import { useStoreToken } from '@/services/auth';

export const RefusedArticlesToPickup = ({
  request,
  articles,
}: {
  request: RequestWithRelations;
  articles: ArticleWithRelations[];
}) => {
  const getArticleName = useGetArticleName();
  const storeToken = useStoreToken();

  if (storeToken) {
    return (
      <AlertBar
        title={
          <Trans id="client.articles.refused-articles-to-pickup.message.non-embedded">
            The client refused the services for{' '}
            <Plural value={articles.length} one="# item" other="# items" /> -{' '}
            {articles.map((article) => getArticleName({ article })).join(',')} - of the initial
            request. They have been notified to come pick{' '}
            <Plural value={articles.length} one="it" other="them" /> up at your store.
          </Trans>
        }
        type="warning"
        icon={<IconWarning />}
        size="large"
      />
    );
  }

  return (
    <AlertBar
      title={
        <Trans id="client.articles.refused-articles-to-pickup.message">
          You refused the services for{' '}
          <Plural value={articles.length} one="# item" other="# items" /> -{' '}
          {articles.map((article) => getArticleName({ article })).join(',')} - of your initial
          request. Please, come pick <Plural value={articles.length} one="it" other="them" /> up at
          the {request.store?.name} store:
        </Trans>
      }
      type="warning"
      icon={<IconWarning />}
      size="large"
    >
      <ContactDetails
        type="store"
        email={request.store?.address?.contactEmail}
        address={request.store?.address}
        phone={request.store?.contactInfo?.phone}
        openingHours={request.store?.storeConfig?.openingHours}
      />
    </AlertBar>
  );
};
